import React from 'react';
import { useAuth } from 'react-oidc-context';
import { resources } from '../resources';
import { LogIn, Loader2 } from 'lucide-react';
import { HarbourLogo } from '../components/shared/Logo';

export const Login: React.FC = () => {
  const auth = useAuth();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8 bg-card p-10 rounded-3xl border border-border shadow-xl">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <HarbourLogo size={56} showText />
          </div>
          <h1 className="text-3xl font-extrabold text-foreground tracking-tight">{resources.login.title}</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            {resources.login.tagline}
          </p>
        </div>

        <div className="mt-10 space-y-4">
          <button
            onClick={() => auth.signinRedirect()}
            disabled={auth.isLoading}
            className="w-full flex items-center justify-center gap-3 px-4 py-4 border border-input rounded-2xl shadow-sm text-sm font-bold text-foreground bg-card hover:bg-muted transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {auth.isLoading ? (
              <Loader2 className="w-5 h-5 animate-spin text-primary" />
            ) : (
              <LogIn className="w-5 h-5 text-primary" />
            )}
            {auth.isLoading ? resources.login.signInLoading : resources.login.signIn}
          </button>
        </div>

        <div className="mt-8 pt-8 border-t border-border text-center">
          <p className="text-xs text-muted-foreground">
            {resources.login.legalNote}
          </p>
        </div>
      </div>
    </div>
  );
};
